import { render, staticRenderFns } from "./PageNavbar.vue?vue&type=template&id=463eb037&scoped=true"
import script from "./PageNavbar.vue?vue&type=script&lang=ts"
export * from "./PageNavbar.vue?vue&type=script&lang=ts"
import style0 from "./PageNavbar.vue?vue&type=style&index=0&id=463eb037&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463eb037",
  null
  
)

export default component.exports